(function () {
  // JavaScript for the progress bar
  document.addEventListener('DOMContentLoaded', function () {
    const progressBar = document.getElementById('post-progress');
    const totalHeight = document.body.scrollHeight - window.innerHeight;

    function updateProgressBar() {
      if (!progressBar) return;
      const progress = (window.pageYOffset / totalHeight) * 100;
      progressBar.style.width = progress + '%';
    }

    // Call the function on page load and on scroll
    updateProgressBar();
    window.addEventListener('scroll', updateProgressBar);
  });
})();
